module.exports = __webpack_public_path__ + "img/Coupé.2cd51284.jpg";